import { ReactNode, memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import QriosLogo from '../../../assets/svg/qriosLogoColor.svg';

const useStyles = makeStyles((theme: Theme) => ({
  backgroundContainer: {
    width: '100%',
    minHeight: '100%',
    padding: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  overflowContainer: {
    height: '100%'
  },
  contentContainer: {
    position: 'relative',
    height: '100%'
  },
  img: {
    opacity: 0.1,
    zIndex: -100,
    position: 'absolute',
    userSelect: 'none',
    width: '50%',
    height: '90%',
    right: '5%'
  }
}));

interface Props {
  children: ReactNode;
  title: string;
}

const WithQriosBackground = ({ children, title }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.overflowContainer}>
      <Box className={classes.backgroundContainer}>
        <img className={classes.img} alt="logo" src={QriosLogo} />
        <Box className={classes.contentContainer}>
          <Box mb={5}>
            <Typography variant="h1" align="center">
              {title}
            </Typography>
          </Box>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default memo(WithQriosBackground);
